import { AuthActionsProvider } from "@modules/auth/provider/AuthActionsProvider";
import { MappedLocales } from "@modules/shared/localization/const/language";
import i18next from "@modules/shared/localization/i18n";
import { useNavigate } from "@tanstack/react-router";
import { getDefaultOptions, setDefaultOptions } from "date-fns";
import { NuqsAdapter } from "nuqs/adapters/react";
import { I18nextProvider } from "react-i18next";
import { getCookie } from "@utils/cookies";
import { USER_ACCESS_TOKEN_KEY } from "../../../../consts/keys";
import type { PropsWithChildren } from "react";
import { ShopProvider } from "@/modules/shopify/ShopProvider";

export const Providers: React.FC<PropsWithChildren> = ({ children }) => {
  const navigate = useNavigate();
  const initialAccessToken = getCookie(USER_ACCESS_TOKEN_KEY);

  if (!getDefaultOptions().locale) {
    // needed for initial render to be in the correct language
    i18next.emit("initialized");
  }

  i18next.on("initialized", () => {
    setDefaultOptions({
      locale: MappedLocales.get(i18next.language),
    });
  });

  i18next.on("languageChanged", async (lng: string) => {
    const defaultOptions = getDefaultOptions();

    if (defaultOptions.locale?.code !== lng) {
      setDefaultOptions({
        locale: MappedLocales.get(lng),
      });
    }

    if (!lng) return;

    await navigate({
      to: ".",
      params: { locale: lng },
    });
  });

  return (
    <ShopProvider customerAccessToken={initialAccessToken}>
      <I18nextProvider i18n={i18next} defaultNS={"translation"}>
        <AuthActionsProvider>
          <NuqsAdapter>{children}</NuqsAdapter>
        </AuthActionsProvider>
      </I18nextProvider>
    </ShopProvider>
  );
};
